import dayjs from 'dayjs'
import { formats } from '../theme'

export const NO_DATE_PLACEHOLDER = '--'
export const EXCEL_DATE_NUM_FMT = formats.date.toLowerCase()

export type ReportDateCellAttrs =
  | { kind: 'date'; display: string; isoDate: string }
  | { kind: 'placeholder'; display: typeof NO_DATE_PLACEHOLDER }

const placeholderAttrs: ReportDateCellAttrs = {
  kind: 'placeholder',
  display: NO_DATE_PLACEHOLDER,
}

export function toReportDateCellAttrs(
  value: string | null | undefined,
  applicable = true,
): ReportDateCellAttrs {
  if (!applicable || value == null || value === '') {
    return placeholderAttrs
  }

  const parsed = dayjs(value)
  if (!parsed.isValid()) {
    return placeholderAttrs
  }

  return {
    kind: 'date',
    display: parsed.format(formats.date),
    isoDate: parsed.format('YYYY-MM-DD'),
  }
}
